import 'vue-smooth-picker/dist/css/style.css'
import SmoothPicker from 'vue-smooth-picker'
import Vue from "vue"
Vue.use(SmoothPicker)